
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";

export const Accordion = ({ title, children, rightIcon, subtitle, bgColor, titleClassName = "" }: { title: React.ReactNode; children: React.ReactNode; rightIcon?: React.ReactNode; subtitle?: React.ReactNode; bgColor?: string; titleClassName?: string }) => {
  const [open, setOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [maxHeight, setMaxHeight] = useState<number>(0);

  useEffect(() => {
    if (contentRef.current) {
      setMaxHeight(contentRef.current.scrollHeight + 16);
    }
  }, [open, children]);

  return (
    <div>
      <div
        className={clsx("flex flex-col gap-4 cursor-pointer select-non p-4 border-gray-100",
           open && "border-b",
          bgColor && open ? `${bgColor} rounded-t-lg` : "",
          bgColor && !open ? `${bgColor} rounded-lg` : "",
          titleClassName,
        )}
        onClick={() => setOpen((prev) => !prev)}
      >
        <div className="flex items-center justify-between gap-2">
          {title}
          <div className="flex items-center gap-2">
            {rightIcon}
            <button
              type="button"
              aria-expanded={open}
              aria-label={open ? "Fermer" : "Ouvrir"}
              onClick={(e) => {
                e.stopPropagation();
                setOpen((prev) => !prev);
              }}
            >
              <ChevronDownIcon
                className={clsx(
                  "h-5 w-5 transition-transform duration-300",
                  open && "rotate-180"
                )}
              />
            </button>
          </div>
        </div>
        {subtitle}
      </div>
      <div
        ref={contentRef}
        className={`transition-all duration-300 overflow-hidden`}
        style={{ maxHeight: open ? maxHeight : 0 }}
      >
        {children}
      </div>
    </div>
  );
};
